import { getOSSAuth } from '@/api/authAPI'
import axios from '@/api/config'

export function dataURLtoFile (dataurl, filename) {
  var arr = dataurl.split(','); var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export function FiletoDataURL (file) {
  return window.URL.createObjectURL(file)
}

export function BlobtoFile (blob, name) {
  return new window.File([blob], name, { type: blob.type })
}

export function DatatoDataURL (data) {
  let files = new window.File([data], data.name, { type: data.type })
  return window.URL.createObjectURL(files)
}

export async function getOssFile (path, credentials) {
  let OSS = require('ali-oss')
  let client = new OSS({
    region: 'oss-cn-shanghai',
    accessKeyId: credentials.AccessKeyId,
    accessKeySecret: credentials.AccessKeySecret,
    stsToken: credentials.SecurityToken,
    bucket: process.env.VUE_APP_OSS_BUCKET
  })
  try {
    let result = await client.get(path)
    return FiletoDataURL(BlobtoFile(new Blob([result.content.buffer]), 'test'))
  } catch (e) {
    console.log(path)
    console.log(e)
    return 0
  }
}

export function getOssAuth () {
  if (sessionStorage.OssCredential) {
    return JSON.parse(sessionStorage.OssCredential)
  } else {
    axios.get(getOSSAuth)
      .then((credential) => {
        sessionStorage.OssCredential = JSON.stringify(credential.data.Credentials)
        return JSON.parse(sessionStorage.OssCredential)
      })
  }
}
